// The follow gate's memory.
//
// Worth being clear about what this is: a funnel, not a lock. Neither Instagram
// nor X will tell a third party whether someone follows you, so nothing here
// can verify a follow, and nothing tries to. It puts the accounts in front of
// somebody at the moment they want something, then takes them at their word.
//
// The content behind it also ships in the page bundle, so this was never going
// to keep anyone determined out. It is there to earn follows from the many
// people who will happily give one, not to stop the few who would not.

const KEY = 'library-access';

export function useFollowGate() {
  const unlocked = useState('followGate', () => false);

  // Read on mount rather than at import: localStorage does not exist while the
  // page is being prerendered.
  function restore() {
    if (typeof window === 'undefined') return;
    try {
      unlocked.value = window.localStorage.getItem(KEY) === 'true';
    } catch {
      // private mode; the gate simply asks again next time
    }
  }

  function unlock() {
    unlocked.value = true;
    try {
      window.localStorage.setItem(KEY, 'true');
    } catch {
      // not being able to remember is survivable
    }
  }

  return { unlocked, restore, unlock };
}
